module.exports = __webpack_public_path__ + "static/unitedhealthcare-emblem-8c583a3d4b512696b31797d7f5f9f834.png";